import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent, LinkComponent, QrComponent, TileComponent } from '@tecalisdev/infinity';
import { AuthService } from 'src/app/core/services/auth.service';
import { IProcessConfig } from 'src/app/user-identification/models/user-identification';
import { ConfigService } from '../../services/config/config.service';

@Component({
	selector: 'app-device-not-allowed',
	imports: [TranslatePipe, TileComponent, QrComponent, LinkComponent, IconComponent],
	templateUrl: './device-not-allowed.component.html',
	styleUrl: './device-not-allowed.component.scss',
})
export class DeviceNotAllowedComponent {
	public auth = inject(AuthService);
	public configService = inject(ConfigService);

	public generalConfig?: IProcessConfig;

	constructor() {
		this.configService.getConfig().subscribe((config: IProcessConfig) => {
			if (config) this.generalConfig = config;
		});
	}
}
